module.exports = __webpack_public_path__ + "static/media/9.93c5bad5.png";